import { ProgressSpinner } from "@constellation-academy/framework-react-components";
import { Suspense } from "react";
import { useTranslation } from "@i18n/hooks";
import { DiscountActionsQueryContainer } from "./discount-actions-query-container";
import { DiscountActionSearchContextProvider } from "./discount-actions.context";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const DiscountActionsScreen = ({ isArchivePage = false }: { isArchivePage?: boolean }) => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions(["UserInAccountPermission_DiscountAdmin_Read"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen
			title={isArchivePage ? t("discounts.archivedActions") : t("discounts.activeActions")}
		>
			<Suspense fallback={<ProgressSpinner />}>
				<DiscountActionSearchContextProvider isArchivePage={isArchivePage}>
					<DiscountActionsQueryContainer />
				</DiscountActionSearchContextProvider>
			</Suspense>
		</BaseScreen>
	);
};
